import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { resolveRoleHome } from '../../v2/js/utils/roleHomeRoutes';
import { ProfileDispositionEnum, SourceTypeEnum, UserTypeEnum } from '../api';
import { SessionContext } from '../app/contexts/SessionContext';

export const HomeRedirect = () => {
  const { user } = useContext(SessionContext);

  if (!user) {
    return <Navigate to="/" />;
  }

  if (user.user_type === UserTypeEnum.PROVIDER) {
    // PEND_ONBOARD: marketplace provider who hasn't finished onboarding.
    // Soft redirect — only at login/home. They can browse freely after "Finish Later".
    if (
      user.source_type === SourceTypeEnum.MARKETPLACE &&
      user.profile_disposition !== ProfileDispositionEnum.MKTPLC_COMPLETE
    ) {
      return <Navigate to="/app/provider/onboarding" />;
    }
    // PEND_REGISTRATION: sourced provider who hasn't finished registration.
    if (
      user.source_type == SourceTypeEnum.ORGANIZATION &&
      user.profile_disposition !== ProfileDispositionEnum._1099_COMPLETE
    ) {
      return <Navigate to="/register/provider/sourced" />;
    }

    return <Navigate to="/app/provider/home" />;
  }

  if (user.user_type === UserTypeEnum.HEALTHCARE_ENTITY_REP) {
    const homeUrl = resolveRoleHome(
      user.healthcare_entity_rep_role,
      '/app/healthcare-entity/providers'
    );
    return <Navigate to={homeUrl} />;
  }

  if (user.user_type === UserTypeEnum.STAFF) {
    return <Navigate to="/staff/home" />;
  }

  return <Navigate to="/" />;
};
